module.exports = __webpack_public_path__ + "media/Tapping Explore More Button.5aa441ac.mp3";